import axios from "axios";


const URL_SERVIDOR = process.env.VUE_APP_SERVER_API;
//process.env.VUE_APP_SERVER_API + "/backend/public/"
// "http://127.0.0.1:8000/"
// "http://192.168.64.131:8000/"
// "http://189.253.52.130:8081/backend/public/"
// "http://luthue.dyndns.org:8081/backend/public/"

const API_URL = URL_SERVIDOR +  "api/";

class LuthueDigital {
    
    //Functiones de toma de datos
    login(params) {
        return axios.post(API_URL + "cliente", params);
    }

    modificarContrato(params) {
        return axios.post(API_URL + "modificar_contrato", params);
    }

    generarGuia(params) {
        return axios.post(API_URL + "generar_guia", params);
    }   

    generarGuiaTest(params) {
        return axios.post(API_URL + "generar_guia_test", params);
    }

    consultarFolios(params) {
        return axios.post(API_URL + "folios", params);
    }

    consultarEnvios(params) {
        return axios.post(API_URL + "consultar_envios", params);
    }

    modificarCliente(params) {
        return axios.post(API_URL + "modificar", params);
    }

    
    consultarDetalles(params) {
        return axios.post(API_URL + "consultar_detalle", params);
    }

        
    aceptar_contrato(params) {
        return axios.post(API_URL + "aceptar_contrato", params);
    }

    consultarContenidos(params) {
        return axios.post(API_URL + "contenido", params);
    }

    consultarPaquetes(params) {
        return axios.post(API_URL + "tipo_paquete", params);
    }

    buscarCodigoPostal(codigo_postal) {
        return axios.get(API_URL + "codigo_postal/" + codigo_postal);
    }

    eliminarCodigo(id) {
        return axios.delete(API_URL + "codigo/" + id);
    }

    informacionCliente(id){
        return axios.get(API_URL + "informacion/" + id);
    }

    buscarRemitentes(id){
        return axios.get(API_URL + "remitente/" + id);
    }

    buscarDestintario(id){
        return axios.get(API_URL + "destinatario/" + id);
    }

    buscarCodigo(codigo){
        return axios.get(API_URL + "codigo/" + codigo);
    }

    buscarRemitenteWeb(params) {
        return axios.post(API_URL + "remitente_web", params);
    }

    buscarDestintarioWeb(params) {
        return axios.post(API_URL + "destintario_web", params);
    }

    //Funciones de funcionamiento
    obtenerUrlServidor(){
        return URL_SERVIDOR;
    }
}

export default new LuthueDigital();